import { dateColumn } from "..";

const lastUpdatedAtColumn = (accessor = "updatedAt", Header = "Last Updated On") =>
  dateColumn(accessor, Header);

export default lastUpdatedAtColumn;
